import React from 'react';

export default function Footer() {

    return (
        <footer className="w-full py-3 md:py-4 lg:py-8 2xl:p-12 bg-smoke mt-auto">
            <div className="container mx-auto flex flex-col items-center px-4 md:px-8">
                <p className='font-jedira text-3xl lg:text-6xl text-lemone'>Let’s Talk.</p>
                <p className='text-base md:text-lg text-lemone text-center mb-2'>©2024 <span className='text-smoke bg-lemone'>Surya</span>. All rights reserved.</p>
            </div>
        </footer>
    );
}
